import type { LiveTeamRow } from "../api/types";
import { agoLabel } from "./ago";

/** Who is signed in right now, team by team — the list the operator reads out
 *  when someone is locked out by a cap. */
export function WhoIsOn({ teams }: { teams: LiveTeamRow[] }): JSX.Element {
  return (
    <section style={{ marginBottom: 24 }}>
      <h2 style={{ fontSize: 18, margin: "0 0 8px" }}>Who's on now</h2>
      {teams.map((t) => (
        <div key={t.slug} style={{ marginBottom: 12 }}>
          <h3 style={{ fontSize: 15, margin: "0 0 4px" }}>
            {t.displayName}
            {t.cap !== null && (
              <span
                style={{
                  marginLeft: 8,
                  fontSize: 12,
                  padding: "1px 6px",
                  borderRadius: 8,
                  background: "#eee",
                }}
              >
                cap {t.cap}
              </span>
            )}
          </h3>
          {t.people.length === 0 ? (
            <p style={{ margin: 0, color: "#666" }}>Nobody on.</p>
          ) : (
            <table style={{ borderCollapse: "collapse", fontSize: 14 }}>
              <tbody>
                {t.people.map((p, i) => (
                  <tr key={`${p.displayName ?? ""}-${i}`}>
                    <td style={{ padding: "2px 12px 2px 0" }}>{p.displayName ?? "(no name)"}</td>
                    <td style={{ padding: "2px 12px 2px 0", color: "#666" }}>
                      {p.devices} {p.devices === 1 ? "device" : "devices"}
                    </td>
                    <td
                      style={{ padding: "2px 12px 2px 0" }}
                      aria-label={p.playing ? "playing" : "idle"}
                    >
                      {p.playing ? "▶" : ""}
                    </td>
                    <td style={{ padding: "2px 0", color: "#666" }}>{agoLabel(p.lastSeenAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      ))}
    </section>
  );
}
